import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../../service/services'
import $ from 'jquery'
import swal from 'sweetalert2'

export default {
    data() {
        return {
            walletChangeID: [{
                data: ''
            },
            {
                data: ''
            },
            {
                data: ''
            },
            {
                data: '-'
            },
            {
                data: ''
            },
            {
                data: ''
            },
            {
                data: ''
            },
            {
                data: '-'
            },
            {
                data: ''
            },
            {
                data: ''
            },
            {
                data: ''
            },
            {
                data: ''
            }
            ],
            numberID: '',
            fac_change: 0
        }
    },
    computed: {
      ...mapState([
        'isLoading',
        'UUID',
        'lang',
        'IDWallet',
        'SaleID',
        'SaleType',
        'PaymentType',
        'accessToken',
        'AmountPayment',
        'reponseStatus',
        'sale_info',
        'printer_step',
        'sale_pay',
        'config',
        'sale_subs_slip',
        'memberProfile',
        'flag_cash'
      ]),
      ...mapMutations(['onMessageWs'])
    },
    methods: {
        addAmount(int) {
            this.Soundclick();
            if (this.numberID.length < 12) {
                this.numberID += int.toString()
                this.walletChangeID[this.numberID.length - 1]['data'] = int
                if (this.numberID.length == 3 || this.numberID.length == 7) {
                    this.numberID += '-'
                    this.walletChangeID[this.numberID.length - 1]['data'] = '-'
                }
            }
            console.log("numberID",this.numberID)
            // console.log("walletChangeID",this.walletChangeID)
        },
        del() {
            if (this.numberID.length > 0) {
                if (this.numberID.length == 4 || this.numberID.length == 8) {
                    this.numberID = this.numberID.substring(0, this.numberID.length - 2)
                    this.walletChangeID[this.numberID.length]['data'] = ''
                } else {
                    this.numberID = this.numberID.substring(0, this.numberID.length - 1)
                    this.walletChangeID[this.numberID.length]['data'] = ''
                }
            }
        },
        checkMobile(val) {
            this.Soundclick()
            console.log('memberProfile: ',this.$store.state.memberProfile)
            if (this.$store.state.memberProfile != null){
              if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
                var str = this.$store.state.memberProfile.phone_number
                var cutBack = str.substring(3, 12);
                var phone_number = "0"+cutBack
              }else{
                var phone_number = this.$store.state.memberProfile.phone_number
              }
              console.log("phone_number:",phone_number)
              this.$store.state.IDWallet = phone_number
              if (this.$store.state.AmountPayment < this.$store.state.total) {
                console.log('this.$store.state.IDWallet1',this.$store.state.IDWallet)
                this.refund()
              } else {
                $('#Refurd').modal('hide')
                switch (this.$store.state.PaymentType) {
                    case 1: this.$router.push('/processcash')
                        break
                    case 2: this.$router.push('/processcredit')
                        break
                    case 3: this.$router.push('/processpromptpay')
                        break
                }
              }
            } else {
            console.log('numberID',this.numberID)
            if (this.numberID.length > 11) {
                if (this.walletChangeID[0]['data'] === '0') {
                  this.$store.state.IDWallet = this.numberID.replace(/-/g, '');
                    // this.walletChangeID.forEach(val => {
                    //     if (val['data'] != '-') {
                    //         this.$store.state.IDWallet += val['data']
                    //     }
                    // })
                    if (this.$store.state.AmountPayment < this.$store.state.total) {
                        console.log('this.$store.state.IDWallet1',this.$store.state.IDWallet)
                        this.refund()
                    } else {
                      $('#Refurd').modal('hide')
                      switch (this.$store.state.PaymentType) {
                          case 1: this.$router.push('/processcash')
                              break
                          case 2: this.$router.push('/processcredit')
                              break
                          case 3: this.$router.push('/processpromptpay')
                              break
                          case 4: this.$router.push('/processwallet')
                              break
                      }
                    }
                } else {
                    let text = ''
                    let title = ''
                    switch (this.lang) {
                        case 0:
                            text = 'Please enter the ID Wallet you want to fill.'
                            title = 'Warning'
                            break
                        case 2:
                            text = '請輸入您要填寫的代碼。'
                            title = '通知'
                            break
                        default:
                            text =
                                'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ให้ถูกต้อง'
                            title = 'แจ้งเตือน'
                            break
                    }
                    swal(title, text, 'warning')
                }
            } else {
                let text = ''
                let title = ''
                switch (this.lang) {
                    case 0:
                        text = 'Please enter the ID Wallet you want to fill.'
                        title = 'Warning'
                        break
                    case 2:
                        text = '請輸入您要填寫的代碼。'
                        title = '通知'
                        break
                    default:
                        text =
                            'กรุณากรอกเบอร์โทรศัพท์ ให้ถูกต้อง'
                        title = 'แจ้งเตือน'
                        break
                }
                swal(title, text, 'warning')
            }
          }
        },
        switchPayment() {
          this.$store.state.flag_cash = 1
          // this.$store.state.IDWallet = '0613351889'
          this.$store.state.IDWallet = this.$store.state.config.client.telephone
          if (this.$store.state.AmountPayment < this.$store.state.total) {
            console.log('this.$store.state.IDWallet1',this.$store.state.IDWallet)
            this.refund()
          } else {
            $('#Refurd').modal('hide')
            switch (this.$store.state.PaymentType) {
                case 1: this.$router.push('/processcash')
                break
                case 2: this.$router.push('/processcredit')
                break
                case 3: this.$router.push('/processpromptpay')
                break
                case 4: this.$router.push('/processwallet')
                break
            }
          }
        },
        refund() {
            this.$store.state.SaleID = 1
            console.log("SaleID : ",this.$store.state.SaleID)
            this.Soundclick()
            $('#Refurd').modal('hide')
            const header = {
                headers: {
                    'x-access-token': this.accessToken
                }
            }

            if (this.$store.state.SaleID == 1) {
                var mode = 'Deposit'
                var payment_type_text = 'cash'
                var type_text = 'Wallet'
                switch (this.lang) {
                    case 0:
                        payment_type_text = 'cash'
                        type_text = 'Wallet'
                        mode = 'Deposit'
                        break
                    case 1:
                        payment_type_text = 'เงินสด'
                        type_text = 'เติมเงิน Wallet'
                        mode = 'เติมเงิน'
                        break
                    case 2:
                        payment_type_text = '現金'
                        type_text = 'Wallet'
                        mode = '存款'
                        break
                }
                this.$store.state.sale_subs = [{
                    line: 1,
                    item_id: '0',
                    item_name: payment_type_text,
                    qty: 1,
                    price_id: 1,
                    price_name: type_text,
                    price: parseFloat(this.$store.state.AmountPayment),
                    unit: ''
                }]
            }

            if (this.$store.state.SaleID !== 5) {
                this.$store.state.ref_number = this.$store.state.txn_id
                this.status_partner = false
            } else {
                this.status_partner = true
            }
            var numberPhone = this.$store.state.IDWallet.substring(1, this.$store.state.IDWallet.length)
            console.log('this.$store.state.IDWallet1',this.$store.state.IDWallet)
            var payload = {
                shift_uuid: this.$store.state.shift_uuid,
                ref_number: this.$store.state.ref_number,
                txn_id: this.$store.state.txn_id,
                type: 'deposit_cash',
                partner: this.status_partner,
                member_phone: '+66' + numberPhone,
                amount: parseFloat(this.$store.state.AmountPayment),
                payment_received: parseFloat(this.$store.state.AmountPayment),
                payment_change: 0,
                flag_cash: 0,
                flag_member: this.$store.state.flag_member,
                payment: {
                    currency: 'THB',
                    b1000: this.sale_pay.b1000,
                    b500: this.sale_pay.b500,
                    b100: this.sale_pay.b100,
                    b50: this.sale_pay.b50,
                    b20: this.sale_pay.b20,
                    c10: this.sale_pay.c10,
                    c5: this.sale_pay.c5,
                    c2: this.sale_pay.c2,
                    c1: this.sale_pay.c1,
                    c050: 0,
                    c025: 0
                },
                pay_change: {
                    b1000: 0,
                    b500: 0,
                    b100: 0,
                    b50: 0,
                    b20: 0,
                    c10: 0,
                    c5: 0,
                    c2: 0,
                    c1: 0,
                    c050: 0,
                    c025: 0
                },
                items: this.$store.state.sale_subs
            }
            console.log(payload)
            console.log(JSON.stringify(payload))
            this.$store.state.isLoading = true
            api.closeSaleV2(
                payload,
                header,
                result => {
                    console.log("result",result)
                    if (result.response == 'success') {
                        this.$socket.sendObj({
                            command: 'receive_close'
                        })
                        if (this.$store.state.SaleID == 5) {
                            const obj = {
                                ref_number: this.$store.state.ref_number,
                                status: 'PROCESSING'
                            }
                            api.getReceiveC9(
                                obj,
                                header,
                                result => {
                                    console.log(result)
                                    let text = ''
                                    let title = ''
                                    switch (this.lang) {
                                        case 0:
                                            text = 'Already refunded to your wallet.'
                                            title = 'Process'
                                            break
                                        case 2:
                                            text = '已退還到您的錢包'
                                            title = '處理'
                                            break
                                        default:
                                            text =
                                                'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว'
                                            title = 'ประมวลผล'
                                            break
                                    }
                                    swal(title, text, 'success')
                                    this.$router.push({
                                        name: 'Main'
                                    })
                                },
                                error => {
                                    alert(JSON.stringify(error))
                                }
                            )
                        } else {
                            console.log(this.$store.state.acl)
                            if (this.$store.state.acl === 1) {
                                this.$socket.sendObj({
                                    command: 'open_cash_box',
                                    data: 10
                                })
                            }
                            let text = ''
                            let title = ''
                            switch (this.lang) {
                                case 0:
                                    text = 'Already refunded to your wallet.'
                                    title = 'Process'
                                    break
                                case 2:
                                    text = '已退還到您的錢包'
                                    title = '處理'
                                    break
                                default:
                                    text =
                                        'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว'
                                    title = 'ประมวลผล'
                                    break
                            }
                            swal(title, text, 'success')
                            this.$router.push({
                                name: 'Main'
                            })
                        }
                    } else {
                        alert(JSON.stringify(result))
                    }
                    this.$store.state.isLoading = false
                },
                error => {
                    console.log(JSON.stringify(error))
                    this.$store.state.isLoading = false
                    alert(JSON.stringify(error))
                }
            )
        }
    },
    mounted() {
      // if (this.$store.state.IDWallet != null && this.$store.state.SaleID == 1) {
      //   this.$router.push('/processcash')
      // }
    }
}



// WEBPACK FOOTER //
// ./src/js/modal/refund.js